<span [ngClass]="{ 'inferred-background': inferredValue }">
  <span
    *ngIf="value >= 0 || (value && value.toString() === 'NM')"
    [ngClass]="{ 'success-color': isPercentChange && value > 0 }"
    >{{ formatedValue }}
    <span *ngIf="percentSymbol">{{ this.percentSymbol }}</span>
  </span>
</span>
<span [ngClass]="{ 'inferred-background': inferredValue }">
  <span *ngIf="value < 0" class="error-color"
    >({{ formatedValue
    }}<span *ngIf="percentSymbol">{{ this.percentSymbol }}</span
    >)</span
  >
</span>
